import { fetchWithToken } from '@utils/api';
import { API_URL } from '@data/constants';

export enum EnglishLevel {
  BASIC = 'Básico',
  INTERMEDIATE = 'Intermedio',
  ADVANCED = 'Avanzado',
  NATIVE = 'Nativo',
}

export interface UserProfile {
  id: number;
  volunteerCode: number | null;
  firstName: string;
  lastName: string;
  email: string;
  dateOfBirth: string;
  province: string;
  city: string | null;
  identificationNumber: string;
  phoneNumber: string;
  instagram: string;
  xTwitter: string;
  tiktok: string;
  skype: string;
  occupation: string;
  education: string;
  previousExperience: string;
  englishLevel: EnglishLevel;
  motivation: string;
  relationWithBasketball: string;
  howDidYouFindUs: string;
  profilePicturePath: string | null;
  profilePictureFullUrl: string | null;
  shirtSize: 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl' | '3xl' | '4xl';
  pantsSize: 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl' | '3xl' | '4xl';
  informAboutFutureEvents: 'yes' | 'no';
  dataPolicyAccepted: boolean;
}

export async function createProfile(
  profile: UserProfile
): Promise<UserProfile> {
  const response = await fetchWithToken(`${API_URL}/api/userprofiles`, {
    method: 'POST',
    body: JSON.stringify(profile),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Error creating profile');
  }

  const { data } = (await response.json()) as { data: UserProfile };

  return data;
}

export async function updateProfile(
  profileId: number,
  profile: UserProfile
): Promise<UserProfile> {
  const response = await fetchWithToken(
    `${API_URL}/api/userprofiles/${profileId}`,
    {
      method: 'PATCH',
      body: JSON.stringify(profile),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error('Error updating profile');
  }

  const { data } = (await response.json()) as { data: UserProfile };

  return data;
}

export interface ProfilePictureResponse {
  storagePath: string;
  storageUrl: string;
}

export async function uploadProfilePicture(
  profilePicture: File
): Promise<ProfilePictureResponse> {
  const formData = new FormData();
  formData.append('profilePicture', profilePicture);

  const response = await fetchWithToken(
    `${API_URL}/api/userprofiles/profile_picture`,
    {
      method: 'POST',
      body: formData,
    }
  );

  if (!response.ok) {
    throw new Error('Error uploading profile picture');
  }

  const { data } = (await response.json()) as {
    data: { storagePath: string; storageUrl: string };
  };

  return data;
}
